import {
  CREATE_TICKET,
  REDEEM_TICKETS,
  REDEEM_TICKET
} from 'types/actions/tickets'
import API from 'store/api'
import { flatten } from 'lodash'

export const redeemTickets = data => {
  return () => {
    data.userDispatchRes.map(x => {
      if (!Array.isArray(x.ticket_holders)) {
        x.ticket_holders = [x.ticket_holders]
      }
    })
    const ticketHolders = data.userDispatchRes
      .map(x => {
        return x.ticket_holders
      })
      .filter(
        z => z[0].holder_user_id.toString() === data.result.user_id.toString()
      )

    if (ticketHolders.length > 0) {
      try {
        let formData = new FormData()
        formData.append('event_id', data.event.auction_code)
        formData.append('holder_id', ticketHolders[0][0].holder_id)
        formData.append('origin', 'admin')
        formData.append('send_sms', 0)
        formData.values()
        //make AJAX call to sign into checkedIn
        API.post('/tickets/redeem')
          .send(formData)
          .then(res => {})
          .catch(err => {
            console.log(err)
          })
      } catch (err) {
        console.log(err)
      }
    }
  }
}

export const redeemTicket = data => {
  return () => {
    let formData = new FormData()
    formData.append('event_id', data.event.auction_code)
    formData.append(
      'holder_id',
      data.purchaseTicketData.purchaseData[0].holder_id
    )
    formData.append('origin', 'admin')
    formData.append('send_sms', 0)
    formData.values()
    //make AJAX call to sign into checkedIn

    API.post('/tickets/redeem')
      .send(formData)
      .then(res => {})
      .catch(err => {
        console.log(err)
      })
  }
}

export const createTicket = data => {
  return () => {
    var payCartFormData = new FormData()
    payCartFormData.append('eid', data.event.auction_code)
    payCartFormData.append('user_id', data.result.user_id)
    payCartFormData.append('user_first_name', data.result.user_first_name)
    payCartFormData.append('user_last_name', data.result.user_last_name)
    payCartFormData.append('user_email', data.result.user_email)
    payCartFormData.append('user_pay_id', data.result.user_pay_id)
    payCartFormData.append('amount', '0.00')
    payCartFormData.append('currency', 'usd')
    payCartFormData.append('ticketArr[0][ticket_id]', 0)
    payCartFormData.append('ticketArr[0][ticket_type]', 'ticket')
    payCartFormData.append('ticketArr[0][calculated_total]', 0)
    payCartFormData.append('ticketArr[0][quantity]', 1)
    payCartFormData.append('ticketArr[0][live_access]', false)
    payCartFormData.append('origin', 'mobile')
    payCartFormData.append('send_sms', 0)

    if (data.result.hasOwnProperty('token')) {
      return API.post('/paycart')
        .send(payCartFormData)
        .set('Authorization', data.result.token)
        .then(response => {
          if (!response.ok) {
            throw Error(response.statusText)
          }
          return response
        })
        .then(response => response.body)
    } else {
      return API.post('/paycart')
        .send(payCartFormData)
        .then(response => {
          if (!response.ok) {
            throw Error(response.statusText)
          }
          return response
        })
        .then(response => response.body)
    }
  }
}



// WEBPACK FOOTER //
// ./src/actions/tickets.js